import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { BaseService } from '../../shared/services/base.service';

import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Quote } from '../../shared/models/quote.interface';
import { Customer } from '../../shared/models/customer.interface';
import { User } from '../../shared/models/user.interface';
import { DashboardSummary } from '../dashboard.summary.interface';
import { DealerHomeSummary } from '../desktop/home-desktop.component';
import { LeadFilter } from '../../lead/models/lead.filter';
import { Router } from '@angular/router';
import { ReleaseSettings } from '../../release/models/releaseSettings.interface';

@Injectable()

export class HomeService extends BaseService {
  baseUrl: string;

  constructor(protected http: HttpClient, router: Router) {
    super(http, router);
  }

  getLeadSummary(filter: LeadFilter): Observable<DealerHomeSummary> {
    let params = new HttpParams();

    if (filter.projectName) params = params.append('projectName', filter.projectName);
    if (filter.dateRange) params = params.append('dateRange', filter.dateRange.toString());
    if (filter.jobTypeId) params = params.append('jobTypeId', filter.jobTypeId.toString());
    if (filter.probability) params = params.append('probability', filter.probability);
    if (filter.salespersonId) params = params.append('salespersonId', filter.salespersonId);
    if (filter.pastDue) params = params.append('pastDue', filter.pastDue.toString());
    if (filter.customerId) params = params.append('customerId', filter.customerId.toString());

    return this.httpGet<DealerHomeSummary>("/lead/summary?" + params.toString());
  }

  getLeads(filter: LeadFilter,
    sortColumn: string, sortDirection: string, page: number, pageSize: number): Observable<Quote[]> {
    let params = new HttpParams();

    if (page != null) params = params.append('page', page.toString());
    if (pageSize != null) params = params.append('pageSize', pageSize.toString());
    if (sortColumn != null) params = params.append('sortColumn', sortColumn);
    if (sortDirection != null) params = params.append('sortDirection', sortDirection);
    if (filter.projectName) params = params.append('projectName', filter.projectName);
    if (filter.dateRange) params = params.append('dateRange', filter.dateRange.toString());
    if (filter.jobTypeId) params = params.append('jobTypeId', filter.jobTypeId.toString());
    if (filter.probability) params = params.append('probability', filter.probability);
    if (filter.salespersonId) params = params.append('salespersonId', filter.salespersonId);
    if (filter.pastDue) params = params.append('pastDue', filter.pastDue.toString());
    if (filter.customerId) params = params.append('customerId', filter.customerId.toString());

    return this.httpGet<Quote[]>("/lead?" + params.toString());
  }

  getDashboardSummary(year: Number, month: Number): Observable<DashboardSummary> {
    let params = new HttpParams()
      .append('year', year.toString())
      .append('month', month.toString());

    return this.httpGet<DashboardSummary>("/dealer/summary?" + params.toString());
  }

  getCustomers(): Observable<Customer[]> {
    return this.httpGet<Customer[]>("/customer");
  }

  getSalespersons(): Observable<User[]> {
    return this.httpGet<User[]>("/user/salesperson");
  }

  getReleaseNotification(): Observable<ReleaseSettings[]> {
    return this.httpGet<User[]>("/release");
  }

  testNotifications(): Observable<any> {
    return this.httpGet<any>("/schedule/TestNightlyWorkOrders");
  }

}
